import { Redirect, Route, useHistory, useParams } from "react-router-dom";
import {
  IonApp,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonLabel,
  IonMenu,
  IonMenuButton,
  IonPage,
  IonRouterOutlet,
  IonSplitPane,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonTitle,
  IonToolbar,
  setupIonicReact,
  useIonLoading,
} from "@ionic/react";
import React from "react";
import { IonReactRouter } from "@ionic/react-router";
import { ellipse, square, triangle } from "ionicons/icons";

// /* Core CSS required for Ionic components to work properly */
// import "@ionic/react/css/core.css";

// /* Basic CSS for apps built with Ionic */
// import "@ionic/react/css/normalize.css";
// import "@ionic/react/css/structure.css";
// import "@ionic/react/css/typography.css";

// /* Optional CSS utils that can be commented out */
// import "@ionic/react/css/padding.css";
// import "@ionic/react/css/float-elements.css";
// import "@ionic/react/css/text-alignment.css";
// import "@ionic/react/css/text-transformation.css";
// import "@ionic/react/css/flex-utils.css";
// import "@ionic/react/css/display.css";

// /* Theme variables */
// import "../../theme/variables.css";
// import "../../theme/pln/splitpane.css";
import { useEffect, useMemo, useState } from "react";
import ToastProvider from "../../providers/ToastProvider/ToastProvider";
import Page404 from "../../pages/web/authentication/404/Page404";
import TestimonialPage from "../../pages/web/TestimonialPage/TestimonialPage";

setupIonicReact();

const WebTestimonial: React.FC = () => {
  console.log("WEB APP");

  const [leadLoading, setLeadLoading] = useState(false);

  const history = useHistory();

  const toastProvider = useMemo(() => {
    return <ToastProvider />;
  }, []);

  return (
    <>
      <IonRouterOutlet animated={false} id="main">
        <Route exact path="/sharestory/:storyID">
          <TestimonialPage nativeMode={false} showBackButton={true} />
        </Route>

        <Route component={Page404}></Route>
      </IonRouterOutlet>
      {toastProvider}
    </>
  );
};

export default WebTestimonial;
